var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.732 12.666c-1.191-.817-1.54-2.44-.808-3.695a5.157 5.157 0 0 0 .697-2.6c0-2.905-2.386-5.239-5.278-5.15-2.677.082-4.91 2.35-4.963 5.044-.02.97.228 1.902.707 2.717a2.783 2.783 0 0 1-.816 3.684 9.338 9.338 0 0 0-4.04 7.115H19.77a9.342 9.342 0 0 0-4.037-7.115zM0 21v-.61c0-3.537 1.739-6.775 4.588-8.73a1.56 1.56 0 0 0 .455-2.058A6.36 6.36 0 0 1 4.17 6.24C4.234 2.899 6.983.104 10.306.003c3.576-.11 6.527 2.776 6.527 6.369a6.376 6.376 0 0 1-.864 3.215c-.412.706-.215 1.619.446 2.073A10.567 10.567 0 0 1 21 20.39V21H0z","id":"path-1"}));
}

User.displayName = "User";

User.defaultProps = {"viewBox":"0 0 21 21"};

module.exports = User;

User.default = User;
